export const exampleTicket = {
    TicketOrder: {
        order_number: 'TEST123-1234567-987654',
    },
    TicketSale: [{ ticket_type_id: 162 }, { ticket_type_id: 215 }],
    TicketType: {
        162: {
            TicketType: {
                id: 162,
                name: 'General Admission',
                non_dollar: 0,
            },
        },
        215: {
            TicketType: {
                id: 215,
                name: 'VIP',
                display_date: '2112-05-16 19:00:00',
                display_date_end: '2112-05-16 22:00:00',
                non_dollar: 0,
            },
        },
    },
    cart: {
        total_amount: '$25.00',
        line_items: [
            {
                description: 'General Admission',
                per_unit: '$4.00',
                fee: '$1.00',
                amount: '$5.00',
                quantity: 1,
            },
            {
                description: 'VIP',
                per_unit: '$8.00',
                fee: '$2.00',
                amount: '$20.00',
                quantity: 2,
            },
        ],
        line_headers: ['Price', 'Quantity', 'Fee', 'Total'],
    },
};
